export default __webpack_public_path__ + "static/about_img-f8e47377dd57b455b2356b5894a2c899.jpg";